<div class="rounded-2xl bg-neutral-0 p-4 pb-0 shadow-md">
  @if (!loading()) {
    <mat-form-field class="w-full">
      <textarea
        matInput
        [formControl]="notesFc"
        aria-labelledby="notes"
        rows="8"
      ></textarea>
    </mat-form-field>
  } @else {
    <div class="mb-4 flex h-[204px] w-full items-center justify-center">
      <shared-loader></shared-loader>
    </div>
  }
</div>
